import { render } from "./HeroiconsSolidX.vue?vue&type=template&id=76cd464c"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidX.vue"]])

export default __exports__